import Vue from 'vue'

/**
 * All direct changes to the state are handled here.
 */
export default {
  setGroups (state, data) {
    Vue.set(state, 'groups', data)
  },

  setStats (state, data) {
    Vue.set(state, 'stats', data)
  },

  setProgBuckets (state, data) {
    Vue.set(state, 'progBuckets', data)
  },

  setDateRange (state, data) {
    let date1 = data[0]
    let date2 = data[1]

    if (date1 > date2) {
      state.minDate = date2
      state.maxDate = date1
    } else if (date1 < date2) {
      state.minDate = date1
      state.maxDate = date2
    } else {
      state.minDate = state.maxDate = date1
    }
  },

  setSelectedGroup (state, data) {
    Vue.set(state, 'selectedGroup', data)

    /* eslint-disable */
    let groupProgBuckets = state.selectedGroup.ProgressBuckets
    let buckets = []

    if (groupProgBuckets.length > 0) {
      _.forEach(groupProgBuckets, (bucket, index) => {
        buckets.push({
          name: bucket.ProgressBucketName,
          min: bucket.MinValue,
          max: bucket.MaxValue,
          label: `Bucket ${index + 1}`
        })
      })

      Vue.set(state, 'progressBuckets', buckets)
    } else {
      Vue.set(state, 'progressBuckets', state.defaultProgBuckets)
    }
    // Vue.set(state, 'progressBuckets', state.defaultProgBuckets)
    /* eslint-enable */
  },

  setGroupCourses (state, data) {
    Vue.set(state, 'groupCourses', data)
  },

  setGroupCoursesCohorts (state, data) {
    Vue.set(state, 'groupCoursesCohorts', data)
  },

  setIsLoading (state, data) {
    Vue.set(state, 'isLoading', data)
  },

  setCurrTabSelection (state, data) {
    Vue.set(state, 'currDashboardTabSelection', data)
  },

  setAllGroupData (state, data) {
    Vue.set(state, 'allGroupData', data)
    /* eslint-disable */
    let allData = state.allGroupData
    let currDashboardTabSelection = state.currDashboardTabSelection
    let groupCourses = allData.GroupProgressDataList;
    let groupCoursesCohorts = []
    let stats = []

    groupCourses = _.map(groupCourses, course => {
      _.set(course, 'isSelected', false)
      return course
    })

    groupCoursesCohorts = _.flatten(_.map(groupCourses, course => {
      return _.map(course.CohortProgressDataList, cohort => {
        _.set(cohort, 'isSelected', false)
        _.set(cohort, 'GroupCourseMasterId', course.GroupCourseMasterId)
        return cohort
      })
    }))

    switch (currDashboardTabSelection) {
      default:
      case 1:
        stats = _.flatten(_.map(groupCoursesCohorts, cohort => {
          return _.map(cohort.DashboardDataList, stat => {
            _.set(stat, 'GroupCourseMasterId', cohort.GroupCourseMasterId)
            _.set(stat, 'MobileProgressPercent', _.parseInt(stat.ProgressPercent) - _.parseInt(stat.WebProgressPercent))
            return stat
          })
        }))
        break
      case 2:
        stats = data
        break

    }

    /**
     * Remove all Unenrolled Stats
     */
    _.remove(stats, (stat) => {
      return stat.isUnEnrolled
    })

    Vue.set(state, 'groupCourses', groupCourses)
    Vue.set(state, 'groupCoursesCohorts', groupCoursesCohorts)
    Vue.set(state, 'stats', stats)
  },

  resetCohorts (state) {
    Vue.set(state, 'groupCoursesCohorts', [])
  },

  resetStats (state) {
    Vue.set(state, 'stats', [])
  },

  setSelectedCohorts (state, data) {
    Vue.set(state, 'selectedCohorts', [])

    if (data.length !== 0 || data !== null || typeof data !== 'undefined') {
      Vue.set(state, 'selectedCohorts', data)
    } else {
      Vue.set(state, 'selectedCohorts', [])
    }
  },

  groupCoursesSelected (state, data) {
    Vue.set(state, 'selectedGroupCourses', data)
  },

  resetState (state) {
    state.access_token = ''
    state.curr_user = {}
    state.course_list = []
    state.selectedCourseObjFromFilter = {}
    state.selectedMasterClassModuleList = []
    state.groupList = []
    state.challengeList = []
    state.isOverlayVisible = false
    state.topicList = []
    state.participantListForCurrentSelectedGroup = []
    state.techniqueList = []
    state.groupCourseList = []
    state.cohortList = []
    state.userList = []
    state.allowToolkitForAll = false
    state.isLessonSwipped = false
    state.createMcqOptions = []
    state.fileRepositoryList = []
    state.isComingFromLogin = false
    state.groups = []
    state.groupCourses = []
    state.groupCoursesCohorts = []
    state.selectedGroup = {}
    state.selectedGroupCourses = []
    state.selectedCohorts = []
    state.stats = []
    state.progressBuckets = []
    state.isLoading = false
    state.setCurrTabSelection = 1
    state.isUserProfileLoaded = false
    state.gccData = {}
  },

  resetGccData (state) {
    Vue.set(state, 'groupCourses', [])
    Vue.set(state, 'groupCoursesCohorts', [])
    Vue.set(state, 'selectedGroupCourses', [])
    Vue.set(state, 'selectedCohorts', [])
    Vue.set(state, 'progBuckets', [])
  },

  setRequestError (state, data) {
    state.requestError = data
  },

  setSelectedCourseIds (state, courses) {
    // eslint-disable-next-line
    state.selectedCourseIds = _.map(courses, course => {
      return course.GroupCourseMasterId
    })
  },

  setSelectedCourses (state, courses) {
    // eslint-disable-next-line
    Vue.set(state, 'selectedGroupCourses', [])

    if (courses.length !== 0 || courses !== null || typeof courses !== 'undefined') {
      Vue.set(state, 'selectedGroupCourses', courses)
    } else {
      Vue.set(state, 'selectedGroupCourses', [])
    }
  },

  deselectAllCourses (state) {
    _.forEach(state.groupCourses, course => {
      if (course.isSelected) {
        Vue.set(course, 'isSelected', false)
      }
    })
    _.forEach(state.groupCoursesCohorts, cohort => {
      if (cohort.isSelected) {
        Vue.set(cohort, 'isSelected', false)
      }
    })
  },

  selectAllCourses (state) {
    _.forEach(state.groupCourses, course => {
      if (!course.isSelected) {
        Vue.set(course, 'isSelected', true)
      }
    })
    _.forEach(state.groupCoursesCohorts, cohort => {
      if (!cohort.isSelected) {
        Vue.set(cohort, 'isSelected', true)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js